<template>
    <div>
        <div v-if="is_can_use">
            <!-- 單一頁 -->
            <router-link class="item"
                v-if="!service_config_menu.items"
                :to="{name: $store.state.initialize_statuses.sidebar ? service_config_menu.name : null}">
                <i class="icons">
                    <i v-if="service_config_menu.icon" :class="service_config_menu.icon+' icon'"></i>
                    <span> {{ $t('ui.links.menu.'+service_config_menu.name) }} </span>
                </i>
            </router-link>

            <!-- 含有子項目 -->
            <SidebarDropdown
                v-if="service_config_menu.items"
                :service_config_menu="service_config_menu"
            >
            </SidebarDropdown>
        </div>
        <div v-else class="item cannot_use" :data-tooltip="$t('ui.general.cannot_use')" data-position="right center">
            <i class="icons">
                <i :class="service_config_menu.icon+' icon'"></i>
                <span> {{ $t('ui.links.menu.'+service_config_menu.name) }} </span>
            </i>
        </div>
    </div>
</template>

<script>
import SidebarDropdown from '@partials/provider/sidebar_dropdown.vue'

export default {
    props: {
        service_config_menu: {
            default: () => { return {} },
            type: Object
        },
    },
    data() {
        return {
            is_can_use: this.check_can_use_current_menu(),
        }
    },
    computed: {
        service_config() {
            return this.$store.state.provider.service_config
        },
        env() {
            return ENV.NODE_ENV
        },
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        check_can_use_current_menu() {
            try {
                if (!this.service_config_menu.items) {
                    var result = _.findLast(this.$store.state.provider.theme_menu, (menu_name) => {
                        return this.service_config_menu.name == menu_name
                    })
                    throw (result) ? true : false
                } else {
                    throw this.check_can_use_current_menu_items()
                }
            } catch (result_boolean) {
                return result_boolean
            }

            return false
        },
        check_can_use_current_menu_items() {
            var reslut = []

            try {
                _.forEach(this.service_config_menu.items, (item) => {
                    reslut.push(
                        _.findLast(this.$store.state.provider.theme_menu, (menu_name) => {
                            return item.name == menu_name
                        })
                    )
                })
                _.remove(reslut, _.isUndefined)
                return (reslut.length) ? true : false
            } catch (e) {
                return false
            }

            return false
        },
    },
    components: {
        SidebarDropdown,
    },
}
</script>


<style lang="scss">
    @import "../../../assets/stylesheets/sidebar.scss";
</style>
